import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Swiper as SwiperClass, Autoplay } from 'swiper/core'
import COVERAPP from './utils/COVERAPP'

import 'normalize.css'
import './assets/less/common.less'
import 'swiper/swiper-bundle.css'

import App from './App.vue'
import router from './router'
import store from './store'


import './utils/rem'

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'https://actapi.thepage.cn' : 'https://actapi.thepage.cn';
Vue.use(VueAxios, axios);
Vue.prototype.COVERAPP = COVERAPP;
Vue.prototype.$request = async (url, method = 'get', data) => {
  const res = await axios.request({
    url,
    method,
    data,
    params: method === 'get' ? data : '',
    timeout: 10000,
  });

  if (res.status === 200) {
    return res.data;
  }

  return false;
}

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
SwiperClass.use([Autoplay])

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
